import { IAddPetForCustomerFormProps } from "../../CustomerDetails/interface";
import AddCustomerForms from "../AddCustomerForms";

const AddPetForCustomerForm: React.FC<IAddPetForCustomerFormProps> = () => {
  return (
    <div className="mb-20">
      <AddCustomerForms addressLayout="MULTI" forUpdate={false} layoutFor="PET" />
    </div>
  );
};
export default AddPetForCustomerForm;
